const night = {
    50: '#e1e3e8',
    100: '#b5bac5',
    200: '#848c9e',
    300: '#535d77',
    400: '#2e3b5a',
    500: '#09183d',
    600: '#081537',
    700: '#06112f',
    800: '#050e27',
    900: '#02081a',
    A100: '#5870ff',
    A200: '#2544ff',
    A400: '#0022f1',
    A700: '#001fd8',
    'contrastDefaultColor': 'light',
};

export default night;
